export default [{
  label: 'Östliche Bundesländer',
  x: new Date(2017, 8, 1),
  y: 24,
  xMobile: new Date(2016, 11, 1),
  yMobile: 24.5,
  class: 'east',
  style: {
    color: '#FF9432',
  }
}, {
  label: 'Bundesdurchschnitt',
  x: new Date(2018, 7, 1),
  y: 17.25,
  xMobile: new Date(2018, 1, 1),
  yMobile: 16,
  class: 'avg',
  style: {
    color: '#777',
  }
}, {
  label: 'Westliche Bundesländer',
  x: new Date(2017, 8, 1),
  y: 5.5,
  xMobile: new Date(2017, 8, 1),
  yMobile: 5,
  class: 'west',
  style: {
    color: '#6AB6D6',
  }
}]